import { Fragment, useRef, useState, useEffect } from "react";
import Image from "next/image";
import Carousel from "react-elastic-carousel";
import style from "./curation_carousel.module.css";
import useSWR from "swr";
import axios from "axios";
import _ from "underscore";
import { Skeleton } from "@mui/material";
import apiMiddleware from "middlewares/apiMiddleware";
import { useRouter } from "next/router";

function CurationBannerCarousel({ carouselItem }) {
  const router = useRouter();
  const [intervalOnce, setIntervalOnce] = useState(false);
  let curationCarouselRef = useRef(null);
  const breakPoint = [
    { width: 1, itemsToShow: 1 },
    { width: 768, itemsToShow: 2.0 },
  ];

  useEffect(() => {
    if (intervalOnce && carouselItem) return;
    // set loop back to first item if scrolled to last one by counting time
    // Todo find the better way instead of using interval (find better lib)
    // reference to base transition time was 500 and autoplay was 2000 each
    const totalTimeToAnimateToLastPate = carouselItem?.length * (500 + 2000);
    setInterval(() => {
      if (!curationCarouselRef) return;
      curationCarouselRef.goTo(0);
    }, totalTimeToAnimateToLastPate);
    setIntervalOnce(true);
  });

  const noArrow = ({ type, onClick, isEdge }) => {
    return <Fragment></Fragment>;
  };

  const onBannerClickHandler = (e, url, target) => {
    router.push(url);
  };

  return (
    <Fragment>
      <div className={style.curation_carousel_wrapper}>
        <Carousel
          itemsToShow={2}
          itemPadding={[0, 12, 0, 12]}
          showArrows={false}
          renderArrow={noArrow}
          breakPoints={breakPoint}
          enableAutoPlay={true}
          ref={(ref) => (curationCarouselRef = ref)}
        >
          {carouselItem
            ? carouselItem.map((carouselBanner, index) => (
                <div
                  key={index}
                  className={style.carousel_banner_wrapper}
                  onClick={(e) => onBannerClickHandler(e, carouselBanner.linkUrl, carouselBanner.linkTarget)}
                >
                  <div className={style.carousel_banner_image}>
                    <Image src={carouselBanner.image} width={1000} height={377} />
                  </div>
                </div>
              ))
            : _.range(2).map((index) => (
                <div className={style.skeleton_card} key={index}>
                  <Skeleton variant="rectangular" width={"100%"} height={210} />
                </div>
              ))}
        </Carousel>
      </div>
    </Fragment>
  );
}

export default function CurationCarousel() {
  const imageHost = process.env.NEXT_PUBLIC_CONTENT_IMAGE_HOST;
  const contentHost = process.env.NEXT_PUBLIC_CONTENT_API;
  const [bannerList, setBannerList] = useState();
  const fetcher = (url) => axios.get(url, { withCredentials: true }).then((res) => res.data);
  const { data: banners, error } = useSWR(`${contentHost}/products/banners`, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  useEffect(() => {
    if (!banners) return;

    const _mappedBanner = banners.map((banner) => {
      return {
        ...banner,
        image: imageHost + banner.image,
      };
    });
    setBannerList(_mappedBanner);
  }, [banners]);

  return <CurationBannerCarousel carouselItem={bannerList} />;
}
